/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultUpdateServer } from "../../funcs/llmMcpVaultUpdateServer.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateMcpServerRequest$inboundSchema,
};

export const tool$llmMcpVaultUpdateServer: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-update-server",
  description: `Update MCP server

Partially updates a user-owned MCP server configuration.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultUpdateServer(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
